module.exports = __webpack_public_path__ + "img/bank.8230f7f8.svg";